<template>
  <mj-button
    v-if="next"
    class="btn-primary"
    @click="loadMore"
  >
    mehr anzeigen
  </mj-button>
</template>

<script>
import SpotifyService from '@/services/api/SpotifyService';

export default {
  name: 'SpotifyLoadMoreTracks',

  props: {
    next: {
      type: String,
      default: null,
    },
  },

  methods: {
    loadMore() {
      SpotifyService.request(this.next)
        .then(data => {
          this.$emit('new-tracks', data.tracks.items);
          this.$emit('next-tracks', data.tracks.next);
        });
    },
  },

};
</script>
